define('middleware-set-entity',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (store) {
        return function (next) {
            return function (action) {
                // export default () => (next) => (action) => {

                if (action.type == 'SET_ENTITY') {
                    action.training = store.getState().training;
                }

                next(action);
            };
        };
    };
});
